export default __webpack_public_path__ + "static/media/astigmatism-test.40aff4d7.png";